export const NAVIGATION_BAR_ANCHOR_CLASS = 'navigation-bar-anchor-component';

export const ANCHOR_COMPONENT = 'NavigationBarAnchorComponent';